import template from './verification-step.html';

export default angular.module('app.holding.dashboard.onboarding')
  .directive('gmwVerificationStep', gmwVerificationStep)
  .name;

function gmwVerificationStep() {
  'ngInject';

  const directive = {
    link,
    replace: true,
    restrict: 'E',
    scope: {
      destination: '@',
      number: '@',
      status: '=',
      code: '=?',
      continue: '=?',
    },
    template,
    transclude: {
      description: 'gmwVerificationStepDescription',
      additionalStatus: '?gmwVerificationStepAdditionalStatus'
    },
  };
  return directive;

  function link(scope, _element, _attrs, _ctrl, transclude) {
    scope.hasAdditionalStatus = transclude.isSlotFilled('additionalStatus');
  }
}



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/onboarding/directives/verification-step/verification-step.js